import { PAGE_CODES } from 'constants/pageCodes';

export const taskTableDefaultOrder = {
  id: 'lastModified',
};

export const AssignmentLabel = {
  ASSIGNED: 'Assigned',
  PENDING: 'Pending',
};

export const FormVariant = {
  ALL_FORMS: 'All forms',
  LOAN_SPECIFIC: 'Loan Specific',
  CREATE_NEW_FORM: 'Create new form',
};

export const formVariantsOptions = [
  {
    name: FormVariant.ALL_FORMS,
    value: FormVariant.ALL_FORMS,
  },
  {
    name: FormVariant.LOAN_SPECIFIC,
    value: FormVariant.LOAN_SPECIFIC,
  },
  {
    name: FormVariant.CREATE_NEW_FORM,
    value: FormVariant.CREATE_NEW_FORM,
    permissions: [PAGE_CODES.TASK_FORM, PAGE_CODES.FORMS],
  },
];
